<template>
    <div class="toastWrapper">
<!--        <div class="imgBg2" :style="{background: `url(${list.cover}) center center/120% no-repeat`}"></div>-->
        <div class="imgBox">
            <div class="imgBg" :style="{background: `url(${list.cover}) center center/120% no-repeat`}"></div>
        </div>
        <div class="mask"><img src="../../assets/img/toastImgMask.png" alt=""></div>

        <div v-if="type==='activity'" class="contentInner" ref="contentInner">
            <div class="cover" @touchstart="changeImageStart" @touchmove="changeImageMove" v-if="list.imageAlbum.length>1">
<!--                两张以上图片轮播展示-->
                <div class="imgBox" ref="cover">
                    <div v-for="(it, ix) in list.imageAlbum" v-show="isRightSlide ? ix===(imgIndex+1)%list.imageAlbum.length : isLeftSlide ? ix===(imgIndex-1+list.imageAlbum.length)%list.imageAlbum.length:false" class="lastImgActivity imgWrapperBg" >
                        <img :src="list.imageAlbum[ix]" lt="活动图片">
                    </div>
                    <div v-for="(it, ix) in list.imageAlbum" v-show="ix === imgIndex" :class="[isRightSlide? 'rightImgActivity':'', isLeftSlide?'imgActivity':'', 'imgWrapperBg']">
                        <img :src="list.imageAlbum[ix]" alt="活动图片">
                    </div>
                </div>
                <div class="dotList">
                    <div v-for="(it, ix) in list.imageAlbum"  :class="['dot', ix===imgIndex ? 'activity':'']" @click="changeImage(ix)"></div>
                </div>
            </div>
            <div v-else class="cover" ref="cover">
                <img class="imgWra" :src="list.imageAlbum[0]" alt="活动图片">
            </div>
            <div class="title">{{list.title}}</div>
            <div class="info" ref="info">
                <div class="time">开始日期: {{formatActivityDate1(list.startTime)}}</div>
                <div class="time">结束日期: {{formatActivityDate1(list.endTime)}}
                </div>
                <div class="address">{{list.address}}</div>
            </div>
            <div class="splitLine" :style="{top: `${top + 0.48}rem`}"></div>
            <div class="contentTitle" :style="{top: `${top + 1}rem`}">详情介绍</div>
            <div class="detail" v-html="list.detail" :style="{top: `${top + 2}rem`, height: `${detailHeight}rem`}"></div>
        </div>

        <div v-else-if="type==='movie'" class="contentInner" ref="contentInner">
            <div class="cover" ref="cover">
                <img class="imgWra" :src="list.cover" alt="电影海报">
            </div>
            <div class="title">{{list.title}}</div>
            <div class="movieInfo" ref="info">
                <div class="infoItem">
                    <span class="infoTitle">导演：</span>
                    <div class="infoContent">
                        <span v-for="(it, ix) in list.director" :key="`direction-${ix}`">{{it}}{{ix+1===list.director.length? '':'、'}}</span>
                    </div>
                </div>
                <div class="infoItem">
                    <span class="infoTitle">主演：</span>
                    <div class="infoContent">
                        <span v-for="(it, ix) in list.actor" :key="`actor-${ix}`">{{it}}{{ix+1===list.actor.length? '':'、'}}</span>
                    </div>
                </div>
                <div class="infoItem">
                    <span class="infoTitle">类型：</span>
                    <div class="infoContent">
                        <span>{{list.kind}}</span>
                    </div>
                </div>
            </div>
            <div class="splitLine" :style="{top: `${top + 0.48}rem`}"></div>
            <div class="contentTitle" :style="{top: `${top + 1}rem`}">剧情</div>
            <div class="detail" :style="{top: `${top + 2}rem`, height: `${detailHeight}rem`}">{{list.detail}}</div>
        </div>
    </div>
</template>

<script>
    import {formatDate} from '@/utils/utils'
    export default {
        name: "ToastInfo",
        props: {
            list: {
                type: Object,
                default: ()=>{}
            },
            type: {
                type: String,
                default: ''
            }
        },
        data(){
            return{
                imgIndex: 0,
                startX: 0,
                isLeftSlide: false,
                isRightSlide: false,
                timer: null,
                top: 0,
                detailHeight: 0,
            }
        },
        mounted(){
            this.type==='activity'&&this.setTimer()
            this.$nextTick(()=>{
                this.top = this.$refs.cover.offsetHeight/2 > this.$refs.info.offsetHeight ? this.$refs.cover.offsetHeight/2 / document.documentElement.clientWidth * 10 : this.$refs.info.offsetHeight / document.documentElement.clientWidth * 10
                this.detailHeight = this.$refs.contentInner.offsetHeight/document.documentElement.clientWidth*10 - this.top - 2.3
            })

        },
        destroyed(){
            clearInterval(this.timer)
        },
        methods: {
            changeImage(index){
                this.imgIndex = index
                this.isLeftSlide = true
                clearInterval(this.timer)
                setTimeout(()=>{
                    this.setTimer()
                },2000)
            },
            changeImageStart(e){
                this.startX = e.changedTouches[0].clientX
                this.isLeftSlide = false
                this.isRightSlide = false
                clearInterval(this.timer)
            },
            changeImageMove(e){
                if(e.changedTouches[0].clientX - this.startX < 0 && !this.isLeftSlide){
                    this.imgIndex = (this.imgIndex + 1) % this.list.imageAlbum.length
                    this.isLeftSlide = true
                    setTimeout(()=>{
                        this.setTimer()
                    },2000)
                }
                if(e.changedTouches[0].clientX - this.startX > 0 && !this.isRightSlide){
                    this.imgIndex = (this.imgIndex - 1  + this.list.imageAlbum.length) % this.list.imageAlbum.length
                    this.isRightSlide = true
                    setTimeout(()=>{
                        this.setTimer()
                    },2000)
                }
            },
            setTimer(){
                clearInterval(this.timer)
                this.timer = setInterval(()=>{
                    this.isLeftSlide = true
                    this.isRightSlide = false
                    this.imgIndex = (this.imgIndex + 1) % this.list.imageAlbum.length
                },2000)
            },
            formatActivityDate1(date){
                return formatDate(date, 'yyyy.MM.dd hh:mm:ss')
            },
            formatActivityDate2(date){
                return formatDate(date, 'M.d')
            }
        }
    }
</script>

<style scoped lang="less">
    .toastWrapper{
        position: relative;
        /*height: 14rem;*/
        height: 100%;
        .imgBg2{
            height: 4.16rem;
            width: 100%;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            border-radius: .5rem .5rem 0 0;
        }
        .imgBg{
            height: 4.1rem;
            width: 100%;
            filter: blur(.3rem);
            z-index: 3;
            border-radius: .5rem .5rem 0 0;
        }
        .mask{
            height: 4.16rem;
            position: absolute;
            top: -.1rem;
            left: 0;
            right: 0;
            border-radius: .5rem .5rem 0 0;
        }
        .contentInner{
            width: 100%;
            min-height: 3rem;
            background-color: #fff;
            position: relative;
            top: -1.01rem;
            border-radius: 0.64rem 0.64rem 0rem 0rem;
            height: calc(100% - 3.15rem);

            .cover{
                width: 2.8rem;
                height: 3.97rem;
                border-radius: .2rem;
                margin-right: .37rem;
                position: absolute;
                left: .67rem;
                right: .43rem;
                top: -1.8rem;
                background-color: #fff;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;
                border-radius: .2rem;
                .imgBox{
                    width: 100%;
                    /*height: 3.5rem;*/
                    flex: 1;
                    overflow: hidden;
                    position: relative;
                    background-color: #fff;
                    display: flex;
                    align-items: center;
                    border-radius: .2rem;
                    .imgWrapperBg{
                        position: absolute;
                        left: 0;
                        top: 0;
                        bottom: 0;
                        right: 0;
                        width: 100%;
                        height: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background-color: #fff;
                        img{
                            width: 92%;
                            height: auto;
                            max-height: 92%;
                        }
                    }
                    .lastImgActivity{
                        animation: .2s out linear;
                    }
                    @keyframes out{
                        0%  {transform: scale(1);opacity: 0}
                        100% {transform: scale(.8);opacity: .8}
                    }
                    .imgActivity{
                        animation: .2s leftMove linear;
                    }
                    @keyframes leftMove{
                        0%  {left: 1.4rem}
                        100% {left: 0}
                    }
                    .rightImgActivity{
                        animation: .2s rightMove linear;
                    }
                    @keyframes rightMove{
                        0%  {left: -1.4rem}
                        100% {left: 0}
                    }
                }
                .dotList{
                    /*position: relative;*/
                    /*bottom: .11rem;*/
                    height: .2rem;
                    display: flex;
                    width: 100%;
                    justify-content: center;
                    align-items: center;
                    .dot{
                        background: darkgray;
                        opacity: 0.5;
                        width: 4px;
                        height: 4px;
                        margin: 0 .08rem;
                        border-radius: 50%;
                    }
                    .activity{
                        background-color: #000;
                        opacity: 1;
                    }
                }
                .imgWra{
                    position: absolute;
                    width: 2.8rem;
                    background-color: #fff;
                    border-radius: .2rem;
                }
            }
            .title{
                width: 5.7rem;
                font-size: 0.48rem;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 0.72rem;
                position: absolute;
                left: 3.84rem;
                right: .43rem;
                top: -2.2rem;
                word-break: break-all;
                height: 2.16rem;
                display: flex;
                align-items: center;
            }
            .info{
                width: 6.2rem;
                position: absolute;
                top: 0rem;
                left: 3.57rem;
                display: flex;
                flex-direction: column;
                justify-content: center;
                font-size: 0.37rem;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #333333;
                line-height: 0.45rem;
                .time{
                    margin-top: .24rem;
                }
                .address{
                    margin-top: .4rem;
                    word-break: break-all;
                }
            }
            .movieInfo{
                width: 5.7rem;
                position: absolute;
                top: .21rem;
                left: 3.84rem;
                display: flex;
                flex-direction: column;
                justify-content: center;
                font-size: 0.37rem;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #333333;
                line-height: .56rem;
                .infoItem{
                    display: -webkit-box;
                }
                .infoTitle{
                    width: 1.2rem;
                }
                .infoContent{
                    width: calc(100% - 1.2rem);
                }
            }
            .splitLine{
                position: absolute;
                top: 2.67rem;
                left: .6rem;
                right: .6rem;
                width: 8.8rem;
                height: 0.05rem;

                background-color: rgba(0, 0, 0, .1);
            }
            .contentTitle{
                position: absolute;
                left: .64rem;
                top: 3.25rem;

                font-size: 0.43rem;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #333333;
                line-height: 0.37rem;
            }
            .detail{
                position: relative;
                top: 4.11rem;
                margin: 0 0.64rem 0 .59rem;
                height: 50%;
                overflow-y: auto;
                word-break: break-all;
            }

        }
    }

</style>
